export const ARROW_DIRECTION_UP = -180;
export const ARROW_DIRECTION_RIGHT = -90;
export const ARROW_DIRECTION_DOWN = 0;
export const ARROW_DIRECTION_LEFT = 90;
export const TOGGLE_ANIMATION_DURATION = '0.3s';
